export default __webpack_public_path__ + "static/media/business_show_8.175f4f28.png";